import React from "react";
import styles from "./Experience.module.css";
import Carousel from "react-elastic-carousel";
import Fade from "react-reveal/Fade";
import Typewriter from "typewriter-effect";

import YouTubeIcon from "@mui/icons-material/YouTube";
import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";
import tsflogin from "../../Assets/Experience/loginapp.png";
import cloudyml from "../../Assets/Experience/cloudyml.png";
import zolatte from "../../Assets/Experience/zolatte.png";
import anjitait from "../../Assets/Experience/anjitait.png";

const Experience = () => {
  const breakpoints = [
    { width: 1, itemsToShow: 1 },
    { width: 500, itemsToShow: 2 },
    { width: 768, itemsToShow: 2 },
    { width: 1200, itemsToShow: 2 },
  ];
  return (
    <div className={styles.experienceMainDiv}>
      <h1 style={{ padding: "0 10% 0 10%" }}>
        <Typewriter
          style={{ fontWeight: "bold" }}
          options={{
            autoStart: true,
            loop: true,
            delay: 40,
            strings: ["Experience()"],
          }}
        />
      </h1>
      <div>
        <div className={styles.experienceDiv}>
          <Carousel breakPoints={breakpoints}>
          <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Full-Time Job/>"}</i>
                </h5>
                <img alt="poster" src={anjitait} />
                <h3>Anjita IT Solutions</h3>
                <p>
                Here, I was assigned with multiple challenging tasks. I refactored the existing codes and 
                made them available for publishing. I built applications with complex UI, integrated REST
                Apis and Firebase push notification. I also implemented Firebase analytics into the applications.
                Especially I worked with creating a game for multiple platforms using Flame package of Flutter with
                only documentation source available. I worked with some native projects in java for android and swift
                for iOS. I also created applications for the existing Shopify stores where user can perform
                everything which can be performed on the original web shopify store. I also worked with integrating
                Deep linking into Android and iOS applications using Branch IO SDK.
                </p>
                <h5 style={{ marginTop: "10px" }}>Jun2023 - Present</h5>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Flutter</div>
                  <div className={styles.techstackItem}>Dart</div>
                  <div className={styles.techstackItem}>iOS</div>
                  <div className={styles.techstackItem}>Android</div>
                  <div className={styles.techstackItem}>Firebase</div>
                  <div className={styles.techstackItem}>JAVA</div>
                  <div className={styles.techstackItem}>Swift</div>
                  <div className={styles.techstackItem}>REST Api</div>
                  <div className={styles.techstackItem}>Graph QL</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Visit Anjita IT Solution website"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://www.anjitait.com/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
          <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Part-Time Internship/>"}</i>
                </h5>
                <img alt="poster" src={zolatte} />
                <h3>Zolatte</h3>
                <p>
                  In this Internship, I was assigned with different apps to work on which 
                  includes a Ride sharing app, Photo sharing app and a Fitness app. In Zolatte, 
                  I got experienced in Building complex User Interfaces, Functionalities and Services
                  and also made the apps ready for deployment over different app publishing stores. 
                  I have managed, reviewed, documented the code and added new features to the existing
                  projects by also ensuring the client objectives and goals are met. Along with App 
                  development, I have also worked on the existing management panels of the apps using 
                  PHP, Laravel and Vuejs.
                </p>
                <h5 style={{ marginTop: "10px" }}>Oct2022 - Jan2023</h5>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Flutter</div>
                  <div className={styles.techstackItem}>Dart</div>
                  <div className={styles.techstackItem}>iOS</div>
                  <div className={styles.techstackItem}>Firebase</div>
                  <div className={styles.techstackItem}>Firestore database</div>
                  <div className={styles.techstackItem}>PHP</div>
                  <div className={styles.techstackItem}>Laravel</div>
                  <div className={styles.techstackItem}>Vue.js</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Visit CloudyML website"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://www.zolatte.com/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Internship/>"}</i>
                </h5>
                <img alt="poster" src={cloudyml} />
                <h3>CloudyML</h3>
                <p>
                  In this Internship, I was assigned with a task to develop a
                  chat system in CloudyML app for the students for doubt support
                  from mentors. In this, mentors were assigned to students in
                  chat groups where students can talk with mentors using text,
                  image, video, audio, pdf, doc, etc file formats. This chat
                  system is a realtime chat support system built using firebase
                  as backend.
                </p>
                <h5 style={{ marginTop: "10px" }}>March2022 - April2022</h5>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Flutter</div>
                  <div className={styles.techstackItem}>Dart</div>
                  <div className={styles.techstackItem}>Firebase</div>
                  <div className={styles.techstackItem}>Firestore database</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Visit CloudyML website"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://www.cloudyml.com/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Graduate Rotational Internship Program/>"}</i>
                </h5>
                <img alt="poster" src={tsflogin} />
                <h3>The Sparks Foundation</h3>
                <p>
                  In this Internship Program I was assigned with a task to
                  implement Social Media Platforms Integration like Twitter and
                  Facebook into an App using their developer APIs, where user
                  can log In the app using either twitter or facebook login
                  credentials.
                </p>
                <h5 style={{ marginTop: "10px" }}>Sep2020 - Oct2020</h5>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Android</div>
                  <div className={styles.techstackItem}>JAVA</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Go to this app's Github repo"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://github.com/Aniketyadav44/LoginApp_Task-5"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <GitHubIcon className={styles.linkBtn} />
                  </a>
                  <a
                    title="Go to this app's Youtube demo video"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://www.youtube.com/watch?v=PlSoK06ijHw"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <YouTubeIcon className={styles.linkBtn} />
                  </a>
                  <a
                    title="See certificate of completion"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://drive.google.com/file/d/1u8-gwWK9jrpckktbG8RgbxXArpYlCTxX/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Experience;
